import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "回单申请超时列表",
    width: "840px",
    "custom-class": "bill-reapply-dialog",
    "close-on-click-modal": false,
    onOpen: _ctx.getList
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "primary",
          loading: _ctx.submitting,
          disabled: !_ctx.tableData.length,
          onClick: _ctx.handleConfirm
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" 确定 ")
          ])),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _ctx.tableData,
        class: "timeout-table",
        "empty-text": "暂无回单申请超时记录"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "userName",
            label: "姓名",
            "min-width": "150",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "身份证号",
            width: "130"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.maskIdCard(scope.row.idCardNo)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "payTime",
            label: "支付时间",
            width: "102",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "getSalaryTime",
            label: "薪资领取时间",
            width: "152",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "金额",
            width: "90",
            align: "right"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.formatAmount(scope.row.paymentAmount)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "项目名称",
            "min-width": "150"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tooltip, {
                content: scope.row.projectName,
                disabled: _ctx.getTextLength(scope.row.projectName) <= 10,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.truncateProjectName(scope.row.projectName)), 1)
                ]),
                _: 2
              }, 1032, ["content", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpen"]))
}